<div class="add-external-layer">
    <div>
        <strong>Option 1:</strong> Enter the URL of an external layer....
    </div>
    <div class="control-group clearfix">
        <label class="pull-left control-label">URL:</label>
        <div class="pull-right field">
            <div class="input-group">
                <input class="input-group-input" type="text" placeholder="URL" [(ngModel)]="layerUrl">
                <span class="input-group-button">
                    <button type="button" class="btn btn-small" (click)="fetchUrl()" [disabled]="!layerUrl">
                        Go!
                    </button>
                </span>
            </div>
            <div class="is-active alert alert-red" *ngIf="warnMsg">
                Error fetching Layer Url.
            </div>
        </div>
    </div>
    <div *ngIf="!layerResult && !dynamicMapServiceResult && !loadingInd">
        <div>
            <strong>Option 2:</strong> Click the button below to upload a zipped "Shapefile."
        </div>

        <div class="control-group clearfix">
            <div>
                <button type="button" class="btn btn-small" (click)="inputFile()">

                    <i class="icon-ui-plusn"></i>Upload Shapefile (zip) ...
                </button>
                <input type="file" #fileInput style="display:none" accept=".zip" (change)="fileChangeEvent($event)" multiple />
            </div>
        </div>
    </div>

    <div *ngIf="fetchSuccess dynamicMapServiceResult" class="control-group clearfix">
        <label class="pull-left control-label">Title:</label>
        <div class="pull-right field">
            <input type="text" placeholder="Enter Layer Title" [(ngModel)]="layerTitle">
        </div>
    </div>

    <div *ngIf="layerResult && externalLayerFilterEnabled" class="control-group clearfix">
        <label class="pull-left control-label">Filter:</label>
        <div class="pull-right field">
            <input type="text" placeholder="Place filter expression here. (Example: CTY_CODE = '1')"
                [(ngModel)]="layerFilter">
        </div>
    </div>

    <div *ngIf="layerResult" class="control-group clearfix">
        <label class="pull-left control-label">Legend:</label>
        <div class="pull-right field">
            <div class="symbol" *ngFor="let symbol of layerResult.legend">
                <div class="symbol-icon">
                    <div class="graphics-symbol"
                        [ngClass]="{'circle':symbol.type === 'circle', 'line': symbol.type === 'line', 'point': symbol.type === 'point', 'text': symbol.type === 'text'}"
                        style="background-color:{{symbol.backgroundColor}}"
                        *ngIf="symbol.backgroundColor && !symbol.imageData"></div>
                    <img class="symbol-img" *ngIf="symbol.imageData"
                        [src]="'data:image/png;base64,' + symbol.imageData" />
                </div>
                <div *ngIf="symbol.label" class="symbol-label">: {{ symbol.label }}</div>
            </div>
        </div>
    </div>

    <div class="control-group clearfix" *ngIf="dynamicMapServiceResult">
        <label class="pull-left control-label">Layers:</label>
        <div class="pull-right field">
            <div class="is-active alert alert-red" *ngIf="!dynamicMapServiceResult.supportsDynamicLayers">
                This MapServer does not support Dynamic Layers. Try adding adding a specific feature layer Url from this
                service instead.
            </div>
            <div class="layers" *ngIf="dynamicMapServiceResult.supportsDynamicLayers">
                <div>
                    <strong>Check the layers you want to add.</strong>
                </div>
                <div class="layer" *ngFor="let layer of dynamicMapServiceResult.layers">
                    <input type="checkbox" [(ngModel)]="layer.visible" /> {{ layer.name }}
                </div>
            </div>
        </div>
    </div>

    <div class="text-right">
        <button class="btn btn-primary add-to-map" (click)="addToMap()"
            [disabled]="!layerResult && (!dynamicMapServiceResult || !dynamicMapServiceResult.supportsDynamicLayers)">Add
            to Map</button>
        <button class="btn btn-clear" (click)="close()">Cancel</button>
    </div>

    <div class="loader is-active padding-leader-3 padding-trailer-3" *ngIf="importService.loading">
        <div class="loader-bars"></div>
        <div class="loader-text">Loading...</div>
    </div>

</div>
